import { tv } from 'tailwind-variants';
import useComments from 'lib/hooks/useComments';
import useInteractions from 'lib/hooks/useInteractions';

import { MIN_CONTENT_LENGTH } from 'features/comments/slice';

import {
  flash,
  Icon,
  withConfirmation,
} from '@frontendmentorio/design-system-v2';

const ConfirmButton = withConfirmation(({ ...props }) => <button {...props} />);

const styles = tv({
  base: [
    'flex',
    'gap-2',
    'items-center',
    'font-bold',
    'font-secondary',
    'italic',
    'text-neutral-500',
    'text-sm',
    'uppercase',
  ],
  variants: {
    isButton: {
      true: ['hover:underline'],
    },
    isHelpful: {
      true: ['text-blue-500'],
    },
  },
});

export default function MarkHelpful({ className, comment, isAwardable }) {
  const { markHelpful } = useComments();
  const { getInteractions } = useInteractions();
  const { isHelpful } = getInteractions(comment);

  const hasModal = !isHelpful && comment.content.length < MIN_CONTENT_LENGTH;

  const handleClick = async () => {
    try {
      await markHelpful(comment);
    } catch (error) {
      flash.error(error.message);
    }
  };

  if (isAwardable) {
    return (
      <ConfirmButton
        className={styles({ class: className, isButton: true, isHelpful })}
        modal={
          hasModal && {
            button: 'Mark as helpful',
            description: `This looks like a short comment. If you’re looking to
            say a quick "thanks", please consider upvoting instead of marking as
            helpful. \n\n The mark as helpful button is there for when someone
            has clearly answered one of your questions or taught you something
            new.`,
            id: 'mark-as-helpful',
            title: 'Are you sure this comment is helpful?',
          }
        }
        onClick={handleClick}
      >
        <Icon name="thumbs-up" style="solid" />
        <span>{isHelpful ? 'Marked' : 'Mark'} as helpful</span>
      </ConfirmButton>
    );
  }

  if (isHelpful) {
    return (
      <div className={styles({ class: className, isHelpful })}>
        <Icon name="thumbs-up" style="solid" />
        <span>Marked as helpful</span>
      </div>
    );
  }

  return null;
}
